module.exports = __webpack_public_path__ + "img/default.0e138de1.png";